export const foundations = {
  color: {
    palette: {
      westfieldRed: {
        value: "#F22D45",
        comment: "Accent colour",
        compliant: "",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#F22D45",
          comment: "Accent colour",
          compliant: "",
        },
        name: "westfieldRed",
        attributes: {},
        path: ["color", "palette", "westfieldRed"],
      },
      licorice: {
        value: "#161719",
        comment: "Background Colour and Text Colour for White and Smoke",
        compliant: "Fully WCAG AAA compliant with Smoke and White",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#161719",
          comment: "Background Colour and Text Colour for White and Smoke",
          compliant: "Fully WCAG AAA compliant with Smoke and White",
        },
        name: "licorice",
        attributes: {},
        path: ["color", "palette", "licorice"],
      },
      quartz: {
        value: "#58585F",
        comment: "Text Colour for White",
        compliant: "Fully WCAG AAA compliant with White",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#58585F",
          comment: "Text Colour for White",
          compliant: "Fully WCAG AAA compliant with White",
        },
        name: "quartz",
        attributes: {},
        path: ["color", "palette", "quartz"],
      },
      manatee: {
        value: "#A2A2A9",
        comment: "Text Colour for Licorice",
        compliant: "Fully WCAG AAA compliant with Licorice",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#A2A2A9",
          comment: "Text Colour for Licorice",
          compliant: "Fully WCAG AAA compliant with Licorice",
        },
        name: "manatee",
        attributes: {},
        path: ["color", "palette", "manatee"],
      },
      ghost: {
        value: "#D9DADD",
        comment: "Dividers and Borders",
        compliant: "",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#D9DADD",
          comment: "Dividers and Borders",
          compliant: "",
        },
        name: "ghost",
        attributes: {},
        path: ["color", "palette", "ghost"],
      },
      smoke: {
        value: "#F5F6F7",
        comment: "Background Colour for screens",
        compliant: "",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#F5F6F7",
          comment: "Background Colour for screens",
          compliant: "",
        },
        name: "smoke",
        attributes: {},
        path: ["color", "palette", "smoke"],
      },
      white: {
        value: "#FFFFFF",
        comment: "Background Colour and Text Colour for Quartz and Licorice",
        compliant: "Fully WCAG AAA compliant with Licorice",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#FFFFFF",
          comment: "Background Colour and Text Colour for Quartz and Licorice",
          compliant: "Fully WCAG AAA compliant with Licorice",
        },
        name: "white",
        attributes: {},
        path: ["color", "palette", "white"],
      },
      blue: {
        value: "#4E77B7",
        comment: "Text Colour",
        compliant: "",
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#4E77B7",
          comment: "Text Colour",
          compliant: "",
        },
        name: "blue",
        attributes: {},
        path: ["color", "palette", "blue"],
      },
      error: {
        value: "#F22D45",
        comment: "Error message",
        compliant: false,
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#F22D45",
          comment: "Error message",
          compliant: false,
        },
        name: "error",
        attributes: {},
        path: ["color", "palette", "error"],
      },
      success: {
        value: "#41DDBB",
        comment: "Success message",
        compliant: false,
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#41DDBB",
          comment: "Success message",
          compliant: false,
        },
        name: "success",
        attributes: {},
        path: ["color", "palette", "success"],
      },
      warning: {
        value: "#F7D373",
        comment: "Warning message",
        compliant: false,
        filePath: "src/color/palette.json",
        isSource: true,
        original: {
          value: "#F7D373",
          comment: "Warning message",
          compliant: false,
        },
        name: "warning",
        attributes: {},
        path: ["color", "palette", "warning"],
      },
    },
  },
  size: {
    font: {
      small: {
        value: "0.75",
        comment: "the small size of the font",
        filePath: "src/size/font.json",
        isSource: true,
        original: {
          value: "0.75",
          comment: "the small size of the font",
        },
        name: "small",
        attributes: {},
        path: ["size", "font", "small"],
      },
      medium: {
        value: "1",
        comment: "the medium size of the font",
        filePath: "src/size/font.json",
        isSource: true,
        original: {
          value: "1",
          comment: "the medium size of the font",
        },
        name: "medium",
        attributes: {},
        path: ["size", "font", "medium"],
      },
      large: {
        value: "2",
        comment: "the large size of the font",
        filePath: "src/size/font.json",
        isSource: true,
        original: {
          value: "2",
          comment: "the large size of the font",
        },
        name: "large",
        attributes: {},
        path: ["size", "font", "large"],
      },
      base: {
        value: "1",
        comment: "the base size of the font",
        filePath: "src/size/font.json",
        isSource: true,
        original: {
          value: "{size.font.medium.value}",
          comment: "the base size of the font",
        },
        name: "base",
        attributes: {},
        path: ["size", "font", "base"],
      },
    },
  },
  spacing: {
    scale: {
      0: {
        value: "0px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "0px",
        },
        name: "0",
        attributes: {},
        path: ["spacing", "scale", "0"],
      },
      1: {
        value: "4px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "4px",
        },
        name: "1",
        attributes: {},
        path: ["spacing", "scale", "1"],
      },
      2: {
        value: "8px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "8px",
        },
        name: "2",
        attributes: {},
        path: ["spacing", "scale", "2"],
      },
      3: {
        value: "12px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "12px",
        },
        name: "3",
        attributes: {},
        path: ["spacing", "scale", "3"],
      },
      4: {
        value: "16px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "16px",
        },
        name: "4",
        attributes: {},
        path: ["spacing", "scale", "4"],
      },
      5: {
        value: "24px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "24px",
        },
        name: "5",
        attributes: {},
        path: ["spacing", "scale", "5"],
      },
      6: {
        value: "32px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "32px",
        },
        name: "6",
        attributes: {},
        path: ["spacing", "scale", "6"],
      },
      7: {
        value: "40px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "40px",
        },
        name: "7",
        attributes: {},
        path: ["spacing", "scale", "7"],
      },
      8: {
        value: "48px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "48px",
        },
        name: "8",
        attributes: {},
        path: ["spacing", "scale", "8"],
      },
      9: {
        value: "56px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "56px",
        },
        name: "9",
        attributes: {},
        path: ["spacing", "scale", "9"],
      },
      10: {
        value: "64px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "64px",
        },
        name: "10",
        attributes: {},
        path: ["spacing", "scale", "10"],
      },
      11: {
        value: "80px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "80px",
        },
        name: "11",
        attributes: {},
        path: ["spacing", "scale", "11"],
      },
      12: {
        value: "96px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "96px",
        },
        name: "12",
        attributes: {},
        path: ["spacing", "scale", "12"],
      },
      13: {
        value: "112px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "112px",
        },
        name: "13",
        attributes: {},
        path: ["spacing", "scale", "13"],
      },
      14: {
        value: "128px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "128px",
        },
        name: "14",
        attributes: {},
        path: ["spacing", "scale", "14"],
      },
      15: {
        value: "144px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "144px",
        },
        name: "15",
        attributes: {},
        path: ["spacing", "scale", "15"],
      },
      16: {
        value: "160px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "160px",
        },
        name: "16",
        attributes: {},
        path: ["spacing", "scale", "16"],
      },
      17: {
        value: "192px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "192px",
        },
        name: "17",
        attributes: {},
        path: ["spacing", "scale", "17"],
      },
      18: {
        value: "224px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "224px",
        },
        name: "18",
        attributes: {},
        path: ["spacing", "scale", "18"],
      },
      19: {
        value: "256px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "256px",
        },
        name: "19",
        attributes: {},
        path: ["spacing", "scale", "19"],
      },
      20: {
        value: "288px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "288px",
        },
        name: "20",
        attributes: {},
        path: ["spacing", "scale", "20"],
      },
      21: {
        value: "320px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "320px",
        },
        name: "21",
        attributes: {},
        path: ["spacing", "scale", "21"],
      },
      22: {
        value: "352px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "352px",
        },
        name: "22",
        attributes: {},
        path: ["spacing", "scale", "22"],
      },
      23: {
        value: "416px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "416px",
        },
        name: "23",
        attributes: {},
        path: ["spacing", "scale", "23"],
      },
      24: {
        value: "480px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "480px",
        },
        name: "24",
        attributes: {},
        path: ["spacing", "scale", "24"],
      },
      25: {
        value: "544px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "544px",
        },
        name: "25",
        attributes: {},
        path: ["spacing", "scale", "25"],
      },
      26: {
        value: "608px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "608px",
        },
        name: "26",
        attributes: {},
        path: ["spacing", "scale", "26"],
      },
      27: {
        value: "672px",
        filePath: "src/spacing/scale.json",
        isSource: true,
        original: {
          value: "672px",
        },
        name: "27",
        attributes: {},
        path: ["spacing", "scale", "27"],
      },
    },
    sizes: {
      "size-0": {
        value: "0px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "0px",
        },
        name: "size-0",
        attributes: {},
        path: ["spacing", "sizes", "size-0"],
      },
      "size-1": {
        value: "4px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "4px",
        },
        name: "size-1",
        attributes: {},
        path: ["spacing", "sizes", "size-1"],
      },
      "size-2": {
        value: "8px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "8px",
        },
        name: "size-2",
        attributes: {},
        path: ["spacing", "sizes", "size-2"],
      },
      "size-3": {
        value: "12px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "12px",
        },
        name: "size-3",
        attributes: {},
        path: ["spacing", "sizes", "size-3"],
      },
      "size-4": {
        value: "16px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "16px",
        },
        name: "size-4",
        attributes: {},
        path: ["spacing", "sizes", "size-4"],
      },
      "size-5": {
        value: "24px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "24px",
        },
        name: "size-5",
        attributes: {},
        path: ["spacing", "sizes", "size-5"],
      },
      "size-6": {
        value: "32px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "32px",
        },
        name: "size-6",
        attributes: {},
        path: ["spacing", "sizes", "size-6"],
      },
      "size-7": {
        value: "40px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "40px",
        },
        name: "size-7",
        attributes: {},
        path: ["spacing", "sizes", "size-7"],
      },
      "size-8": {
        value: "48px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "48px",
        },
        name: "size-8",
        attributes: {},
        path: ["spacing", "sizes", "size-8"],
      },
      "size-9": {
        value: "56px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "56px",
        },
        name: "size-9",
        attributes: {},
        path: ["spacing", "sizes", "size-9"],
      },
      "size-10": {
        value: "64px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "64px",
        },
        name: "size-10",
        attributes: {},
        path: ["spacing", "sizes", "size-10"],
      },
      "size-11": {
        value: "80px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "80px",
        },
        name: "size-11",
        attributes: {},
        path: ["spacing", "sizes", "size-11"],
      },
      "size-12": {
        value: "96px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "96px",
        },
        name: "size-12",
        attributes: {},
        path: ["spacing", "sizes", "size-12"],
      },
      "size-13": {
        value: "112px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "112px",
        },
        name: "size-13",
        attributes: {},
        path: ["spacing", "sizes", "size-13"],
      },
      "size-14": {
        value: "128px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "128px",
        },
        name: "size-14",
        attributes: {},
        path: ["spacing", "sizes", "size-14"],
      },
      "size-15": {
        value: "144px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "144px",
        },
        name: "size-15",
        attributes: {},
        path: ["spacing", "sizes", "size-15"],
      },
      "size-16": {
        value: "160px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "160px",
        },
        name: "size-16",
        attributes: {},
        path: ["spacing", "sizes", "size-16"],
      },
      "size-17": {
        value: "192px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "192px",
        },
        name: "size-17",
        attributes: {},
        path: ["spacing", "sizes", "size-17"],
      },
      "size-18": {
        value: "224px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "224px",
        },
        name: "size-18",
        attributes: {},
        path: ["spacing", "sizes", "size-18"],
      },
      "size-19": {
        value: "256px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "256px",
        },
        name: "size-19",
        attributes: {},
        path: ["spacing", "sizes", "size-19"],
      },
      "size-20": {
        value: "288px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "288px",
        },
        name: "size-20",
        attributes: {},
        path: ["spacing", "sizes", "size-20"],
      },
      "size-21": {
        value: "320px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "320px",
        },
        name: "size-21",
        attributes: {},
        path: ["spacing", "sizes", "size-21"],
      },
      "size-22": {
        value: "352px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "352px",
        },
        name: "size-22",
        attributes: {},
        path: ["spacing", "sizes", "size-22"],
      },
      "size-23": {
        value: "416px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "416px",
        },
        name: "size-23",
        attributes: {},
        path: ["spacing", "sizes", "size-23"],
      },
      "size-24": {
        value: "480px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "480px",
        },
        name: "size-24",
        attributes: {},
        path: ["spacing", "sizes", "size-24"],
      },
      "size-25": {
        value: "544px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "544px",
        },
        name: "size-25",
        attributes: {},
        path: ["spacing", "sizes", "size-25"],
      },
      "size-26": {
        value: "608px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "608px",
        },
        name: "size-26",
        attributes: {},
        path: ["spacing", "sizes", "size-26"],
      },
      "size-27": {
        value: "672px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "672px",
        },
        name: "size-27",
        attributes: {},
        path: ["spacing", "sizes", "size-27"],
      },
      "size-none": {
        value: "0px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "0px",
        },
        name: "size-none",
        attributes: {},
        path: ["spacing", "sizes", "size-none"],
      },
      "size-xs": {
        value: "32px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "32px",
        },
        name: "size-xs",
        attributes: {},
        path: ["spacing", "sizes", "size-xs"],
      },
      "size-sm": {
        value: "64px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "64px",
        },
        name: "size-sm",
        attributes: {},
        path: ["spacing", "sizes", "size-sm"],
      },
      "size-md": {
        value: "128px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "128px",
        },
        name: "size-md",
        attributes: {},
        path: ["spacing", "sizes", "size-md"],
      },
      "size-lg": {
        value: "160px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "160px",
        },
        name: "size-lg",
        attributes: {},
        path: ["spacing", "sizes", "size-lg"],
      },
      "size-xl": {
        value: "224px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "224px",
        },
        name: "size-xl",
        attributes: {},
        path: ["spacing", "sizes", "size-xl"],
      },
      "size-2xl": {
        value: "288px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "288px",
        },
        name: "size-2xl",
        attributes: {},
        path: ["spacing", "sizes", "size-2xl"],
      },
      "size-3xl": {
        value: "352px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "352px",
        },
        name: "size-3xl",
        attributes: {},
        path: ["spacing", "sizes", "size-3xl"],
      },
      "size-4xl": {
        value: "480px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "480px",
        },
        name: "size-4xl",
        attributes: {},
        path: ["spacing", "sizes", "size-4xl"],
      },
      "size-full": {
        value: "100%",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "100%",
        },
        name: "size-full",
        attributes: {},
        path: ["spacing", "sizes", "size-full"],
      },
      "size-half": {
        value: "50%",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "50%",
        },
        name: "size-half",
        attributes: {},
        path: ["spacing", "sizes", "size-half"],
      },
      "size-third": {
        value: "33.333%",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "33.333%",
        },
        name: "size-third",
        attributes: {},
        path: ["spacing", "sizes", "size-third"],
      },
      "size-quarter": {
        value: "25%",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "25%",
        },
        name: "size-quarter",
        attributes: {},
        path: ["spacing", "sizes", "size-quarter"],
      },
      "size-fifth": {
        value: "20%",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "20%",
        },
        name: "size-fifth",
        attributes: {},
        path: ["spacing", "sizes", "size-fifth"],
      },
      "size-max-fixed": {
        value: "1152px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "1152px",
        },
        name: "size-max-fixed",
        attributes: {},
        path: ["spacing", "sizes", "size-max-fixed"],
      },
      "size-max-small-fixed": {
        value: "896px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "896px",
        },
        name: "size-max-small-fixed",
        attributes: {},
        path: ["spacing", "sizes", "size-max-small-fixed"],
      },
      "size-auto": {
        value: "auto",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "auto",
        },
        name: "size-auto",
        attributes: {},
        path: ["spacing", "sizes", "size-auto"],
      },
      "size-icon-sm": {
        value: "16px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "16px",
        },
        name: "size-icon-sm",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-sm"],
      },
      "size-icon-md": {
        value: "24px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "24px",
        },
        name: "size-icon-md",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-md"],
      },
      "size-icon-lg": {
        value: "48px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "48px",
        },
        name: "size-icon-lg",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-lg"],
      },
      "size-icon-xl": {
        value: "64px",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "64px",
        },
        name: "size-icon-xl",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-xl"],
      },
      "size-icon-line-height-none": {
        value: "1em",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "1em",
        },
        name: "size-icon-line-height-none",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-line-height-none"],
      },
      "size-icon-line-height-shorter": {
        value: "1.25em",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "1.25em",
        },
        name: "size-icon-line-height-shorter",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-line-height-shorter"],
      },
      "size-icon-line-height-base": {
        value: "1.5em",
        filePath: "src/spacing/sizes.json",
        isSource: true,
        original: {
          value: "1.5em",
        },
        name: "size-icon-line-height-base",
        attributes: {},
        path: ["spacing", "sizes", "size-icon-line-height-base"],
      },
    },
  },
  typography: {
    lineHeights: {
      none: {
        value: 1,
        filePath: "src/typography/line-heights.json",
        isSource: true,
        original: {
          value: 1,
        },
        name: "none",
        attributes: {},
        path: ["typography", "lineHeights", "none"],
      },
      shorter: {
        value: 1.25,
        filePath: "src/typography/line-heights.json",
        isSource: true,
        original: {
          value: 1.25,
        },
        name: "shorter",
        attributes: {},
        path: ["typography", "lineHeights", "shorter"],
      },
      baseLine: {
        value: 1.5,
        filePath: "src/typography/line-heights.json",
        isSource: true,
        original: {
          value: 1.5,
        },
        name: "baseLine",
        attributes: {},
        path: ["typography", "lineHeights", "baseLine"],
      },
    },
    scale: {
      xs: {
        value: 12,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 12,
        },
        name: "xs",
        attributes: {},
        path: ["typography", "scale", "xs"],
      },
      sm: {
        value: 14,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 14,
        },
        name: "sm",
        attributes: {},
        path: ["typography", "scale", "sm"],
      },
      md: {
        value: 16,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 16,
        },
        name: "md",
        attributes: {},
        path: ["typography", "scale", "md"],
      },
      lg: {
        value: 18,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 18,
        },
        name: "lg",
        attributes: {},
        path: ["typography", "scale", "lg"],
      },
      xl: {
        value: 20,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 20,
        },
        name: "xl",
        attributes: {},
        path: ["typography", "scale", "xl"],
      },
      xl2: {
        value: 24,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 24,
        },
        name: "xl2",
        attributes: {},
        path: ["typography", "scale", "xl2"],
      },
      xl3: {
        value: 28,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 28,
        },
        name: "xl3",
        attributes: {},
        path: ["typography", "scale", "xl3"],
      },
      xl4: {
        value: 32,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 32,
        },
        name: "xl4",
        attributes: {},
        path: ["typography", "scale", "xl4"],
      },
      xl5: {
        value: 40,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 40,
        },
        name: "xl5",
        attributes: {},
        path: ["typography", "scale", "xl5"],
      },
      xl6: {
        value: 48,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 48,
        },
        name: "xl6",
        attributes: {},
        path: ["typography", "scale", "xl6"],
      },
      xl7: {
        value: 52,
        filePath: "src/typography/scale.json",
        isSource: true,
        original: {
          value: 52,
        },
        name: "xl7",
        attributes: {},
        path: ["typography", "scale", "xl7"],
      },
    },
  },
}
export default foundations
